import CollectionMethodSelection from './CollectionMethodSelection';

export default CollectionMethodSelection;
